<template>
    <div>
        <div class="head-bar">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="_save">添加</el-button>
            <el-input v-model="datas.add.kw" placeholder="关键词" clearable></el-input>
        </div>
        <div>
            <el-button type="primary" @click="_load">刷新</el-button>
            <el-tree :data="trees" node-key="id" ref="tree" highlight-current :props="{label:'title'}"
                :expand-on-click-node="false" default-expand-all>
                <div slot-scope="{ node, data }" class="flex">
                    {{data.id}}

                    <el-button type="primary" @click="()=>{_save(0,{pid:data.id})}" icon="el-icon-plus"></el-button>



                    <el-input v-model="data.title" @change="_quick_edit('admin_menus',data.id,'title',data.title)">
                    </el-input>
                    <el-input v-model="data.url" @change="_quick_edit('admin_menus',data.id,'url',data.url)">
                    </el-input>
                    <el-input v-model="data.pid" @change="_quick_edit('admin_menus',data.id,'pid',data.pid)">
                    </el-input>
                    <el-input v-model="data.icon" @change="_quick_edit('admin_menus',data.id,'icon',data.icon)">
                    </el-input>
                    <el-input v-model="data.myorder"
                        @change="_quick_edit('admin_menus',data.id,'myorder',data.myorder)"></el-input>
                    <el-button class="c-danger" @click="_del(data.id)">删除</el-button>
                </div>
            </el-tree>
        </div>
        <el-dialog :title="r.id ? '编辑' : '新增'" :visible.sync="show_save" width="400px">
            <el-form :model="r" ref="r">
                <el-form-item label="标题">
                    <el-input v-model="r.title"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="r.url"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                table: 'admin_menus',
                datas: {
                    order: "level desc"
                },
                trees: []
            };
        },
        created() {
            this._load();
        },
        methods: {

            _load() {
                this.$http.post('admin_menus/tree').then(res => {
                    this.trees = res.data;
                })
            }
        },
    };
</script>
<style lang="scss">
</style>